import React from "react";
import moment from "moment-timezone";
import { Link, useParams } from "react-router-dom";
import AllNflGamesHelper from "../../classes/allNflGamesHelper";
import useDraft from "../../hooks/queryResults/draft/useDraft";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useNflGamesForWeek from "../../hooks/queryResults/useNflGamesForWeek";
import useWeek from "../../hooks/queryResults/useWeek";
import DraftResults from "../draft/DraftResults";
import Box from "../layout/Box";
import MessageBoard from "../messages/MessageBoard";
import Loading from "../ui/Loading";
import LeagueStandings from "./LeagueStandings";
import LeagueWaiversCountdownClock from "./LeagueWaiversCountdownClock";
import LeagueWeekGames from "./LeagueWeekGames";
import styled from "styled-components";
import TransactionsForWeek from "./TransactionsForWeek";

const StyledBlinkingDiv = styled.div`
  animation: blinker 0.5s linear infinite;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;

  @keyframes blinker {
    50% {
      color: #ff9999;
    }
  }
`;

const LeagueSeasonHome = () => {
  const { league, season } = useParams();
  const { draftData, draftQuery } = useDraft();
  const { currentWeek, selectedWeek } = useWeek();
  const { nflGamesData, nflGamesQuery } = useNflGamesForWeek(
    season,
    selectedWeek
  );

  const isLoading = useIsLoading(
    draftData,
    draftQuery,
    nflGamesData,
    nflGamesQuery
  );
  if (isLoading) return <Loading />;

  const nflGamesHelper = new AllNflGamesHelper(nflGamesData);

  const haveAllNflGamesEnded =
    nflGamesHelper.haveAllNflGamesEnded(selectedWeek);

  // todo: deal with the fact that i can't get draft settings because
  // that is dependent on draft state, which context is only available in draft components
  const draftHasEnded = !!draftData.draft.endDate;

  let liveDraftLink = null;

  if (!draftHasEnded)
    liveDraftLink = (
      <Box title={"Live Draft"}>
        <StyledBlinkingDiv>
          <Link to={`/${league}/${season}/draft`}>
            Click here to enter the Live Draft
          </Link>
        </StyledBlinkingDiv>
      </Box>
    );

  let waiversCountdownClock = null;
  if (haveAllNflGamesEnded)
    waiversCountdownClock = <LeagueWaiversCountdownClock />;

  let leagueWeekGames = (
    <LeagueWeekGames
      size={"sm"}
      style={{ marginTop: "1rem" }}
      showWeekLinks={false}
    />
  );

  let standings = <LeagueStandings />;

  let transactions = (
    <Box title={`week ${currentWeek} transactions`} centerContent={true}>
      <div
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          alignItems: "center",
        }}
      >
        <TransactionsForWeek week={currentWeek} />
        <p style={{ marginLeft: "1rem" }}>
          <Link to={`/${league}/${season}/transactions`}>
            View All Transactions
          </Link>
        </p>
      </div>
    </Box>
  );

  let messageBoard = <MessageBoard />;

  let showDraftResults = false;
  if (draftHasEnded) {
    const draftEndedDate = moment(draftData.draft.endDate);
    const now = moment();
    showDraftResults = draftEndedDate.add(7, "days").isAfter(now);
  }
  let draftResults = showDraftResults ? <DraftResults /> : null;

  return (
    <>
      {liveDraftLink}
      {waiversCountdownClock}
      {leagueWeekGames}
      {standings}
      {transactions}
      {messageBoard}
      {draftResults}
    </>
  );
};

export default LeagueSeasonHome;
